import { useMediaQuery } from '@react-hook/media-query';
import React from 'react';

const About = () => {
  const isSmallScreen = useMediaQuery('only screen and (max-width: 670px)');

  return (
    <div className="flex  bg-background flex-col sm:flex-row h-min[100vh] sm:px-6 lg:px-16">
        {/* <div className='h-content '> */}
        <div className={`sm:w-2/5 flex-shrink-0 ${isSmallScreen ? `mt-6` : ""}  flex mt-20  justify-center`}>
        {/* <picture> */}
          {/* For WebP type image below code. */}
          {/* .webp image
          <source srcSet="/image/13.webp" className="h-auto w-[100%] object-cover" type="image/webp" />
        Fallback image format, e.g., .jpg */}
          {/* </picture> */}
        <div>
        <img
          src="/image/About.png"
          alt="About Image"
          className="max-h-full max-w-full object-cover pointer-events-none"
        />
        </div>

      </div>
      {/* Right div */}
      <div className={`sm:w-3/5 py-2 ${isSmallScreen ? `mt-4` : ""} h-auto px-6 sm:px-12 lg:px-4 flex mt-16`}>
        <div className="flex flex-col  ">
          {/* Sub div 1 */}
          <div className=' w-[100%] py-2'>
            <p className=" items-start  font-Montserrat font-bold" style={{fontSize:"26.1px"}}>
              ABOUT US
            </p>
          </div>
          {/* Sub div 2 */}
          <div className='py-2'>
            <p className=" sm:text-base font-bold font-poppins text-justify" style={{fontSize:"14px",fontStyle:"italic"}}>
              Welcome to "VINESH SILK MILLS PRIVATE LIMITED," a leading digital textile printing company dedicated to transforming ideas into vibrant, high-quality textile designs. With our state-of-the-art technology and commitment to innovation, we bring your imagination to life on fabric.
            </p>
          </div>
          {/* Sub div 3 */}
          <div className='py-2'>
            <p className="text-sm sm:text-base sm:px-4 lg:px-0 font-poppins text-justify" style={{fontSize:"16px"}}>
              With years of experience in the industry, we have honed our expertise in digital textile printing. Our team of skilled professionals combines technical knowledge, artistic flair, and a passion for textiles to produce stunning designs that surpass expectations. We invest in the latest digital printing technology to ensure outstanding results. Our advanced printing equipment and software enable us to achieve sharp details, vibrant colors, and precise color matching, while maintaining excellent durability and wash-fastness. We continuously stay updated with emerging trends and innovations to provide our clients with the best possible solutions. Ready to bring your textile designs to life? Contact us today to discuss your project, request samples, or learn more about our services. We look forward to collaborating with you and helping you achieve your textile printing goals.
            </p>
          </div>
        </div>
      </div>
        </div>
    // </div>
  );
};

export default About;
